import React from 'react';
import Alert from 'react-bootstrap/Alert';
import ReactLoading from 'react-loading';

export const Password = props =>{
    const [loading, setLoading] = React.useState(false);

    const [oldPassword, setOldPassword] = React.useState('');
    const [newPassword, setNewPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');

    const [showAlert, setShowAlert] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState('');
    const [alertVariant, setAlertVariant] = React.useState('');

    const [forced, setForced] = React.useState(false);

    //Checks if this is a forced update
    React.useEffect(()=>{
        if(props.forced){
            setForced(true);
        }
    }, [props.forced]);

    const changePassword = (ev) =>{
        ev.preventDefault();
        setShowAlert(false);

        //Check if the new password matches the confirmed password
        if(newPassword !== confirmPassword){
            setAlertMessage('The new passwords do not match');
            setAlertVariant('danger');
            setShowAlert(true);
            return null;
        }

        //Check if the new password is the same as the current password
        if(newPassword === oldPassword){
            setAlertMessage('The new password cannot be the same as your previous password');
            setAlertVariant('danger');
            setShowAlert(true);
            return null;
        }

        setLoading(true);
        //Call API to change password
        fetch(localStorage.getItem('server')+ 'member/update/password', {
            method: 'POST',
            headers: {
                'token': sessionStorage.getItem('token'),
                'memberNumber': sessionStorage.getItem('memberNumber')
            },
            body: JSON.stringify({
                password: oldPassword, 
                newPassword: newPassword,
                memberNumber: sessionStorage.getItem('memberNumber'),
                forced: forced
            })
        })
        .then((response)=>{
            return response.json();
        })
        .then((data)=>{
            setLoading(false);
            if(!data.success){
                setAlertMessage(data.message);
                setAlertVariant('danger');
                setShowAlert(true);
            } else {
                if(forced){
                    props.closeModal(true);
                }
                setAlertMessage('Password has been updated');
                setAlertVariant('success');
                setShowAlert(true);
                setTimeout(()=>{
                    setShowAlert(false);
                }, 5000);
            }
        });
    }

    

    return(
        <div>
            <div className="overlay" hidden={!loading}>
                <ReactLoading className="loading" type={'cylon'} color={'#61dafb'} height={300} width={300} />
            </div>
            <div className="mini-form">
                {!forced ? 
                    <h3 className="text-center"><strong>Update Password</strong></h3>
                    :
                    <div className="text-center">
                        <h3>Hi {props.firstName}</h3>
                        <p>
                            To get started, please update your password.
                        </p>
                    </div>
                }
                <form onSubmit={(ev)=>changePassword(ev)}>
                    {!forced && 
                    <div>
                        <label className="login-label">
                            <strong>Current Password</strong>
                        </label>
                        <input required type="password" className="form-control login-field" onChange={(ev)=>setOldPassword(ev.target.value)} />
                    </div>
                    }
                    <label className="login-label">
                        <strong>New Password</strong>
                    </label>
                    <input required placeholder="Minimum 8 characters" type="password" className="form-control login-field" onChange={(ev)=>{setNewPassword(ev.target.value)}} minLength={8} />
                    <label className="login-label">
                        <strong>Confirm New Password</strong>
                    </label>
                    <input required type="password" className="form-control login-field" onChange={(ev)=>setConfirmPassword(ev.target.value)} minLength={8} />
                    <Alert className="remove-bottom-margin password-alert" show={showAlert} variant={alertVariant}>
                        <p className="remove-bottom-margin">{alertMessage}</p>
                    </Alert>
                    <br/>
                    <button className="btn btn-dark center-btn">Change Password</button>
                </form>
            </div>
        </div>
    )
}